export default function ProgressBar({ value, height = "h-2", color = "brand" }) {
  const colors = {
    brand: "from-brand to-brand-accent",
    green: "from-emerald-500 to-emerald-400",
  };

  return (
    <div className={`bg-gray-100 rounded-full ${height} overflow-hidden`}>
      <div
        className={`${height} rounded-full bg-gradient-to-r ${colors[color]} animate-progress`}
        style={{ width: `${value}%` }}
      />
    </div>
  );
}
